var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../assets/info/ai.png"),"alt":"","srcset":""}}),_c('span',[_vm._v("量体虚拟试衣镜")])])
}]

export { render, staticRenderFns }